import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPaginatedJobType from './paginated-job-type.reducer';

export const selectPaginatedJobTypeState =
  createFeatureSelector<fromPaginatedJobType.PaginatedJobTypeState>(
    fromPaginatedJobType.paginatedJobTypeFeatureKey,
  );

export const selectPaginatedJobTypes = createSelector(
  selectPaginatedJobTypeState,
  (state) => state,
);

export const selectPaginatedJobTypeItems = createSelector(
  selectPaginatedJobTypeState,
  (state) => state.items,
);

export const selectSinglePaginatedJobTypeItem = (uuid: string) =>
  createSelector(selectPaginatedJobTypeItems, (state) =>
    state.find((item) => item.uuid === uuid),
  );

export const selectPaginatedJobMajorTypes = createSelector(
  selectPaginatedJobTypeItems,
  (state) => state.filter((item) => item.major),
);

export const selectPaginatedJobNonMajorTypes = createSelector(
  selectPaginatedJobTypeItems,
  (state) => state.filter((item) => !item.major),
);
